let keyStrIvStr = {
  "keyStr": "JqaBPrHlkBOoCKgI",
  "ivStr": "aWuPNUnUOuvEcBlP"
}
/*
* [encrypt 加密]
*/
function encrypt (content, key, iv) {
  var keyStr = CryptoJS.enc.Utf8.parse(key || keyStrIvStr.keyStr); //密钥，16位
  var ivStr = CryptoJS.enc.Utf8.parse(iv || keyStrIvStr.ivStr); //偏移量，16位
  var encryptResult = CryptoJS.AES.encrypt(content, keyStr, {
    iv: ivStr,
    mode: CryptoJS.mode.CBC, //aes加密模式cbc
    padding: CryptoJS.pad.Pkcs7 //填充
  });
  var result = String(encryptResult);//把object转化为string
  return result;
}

/**
* [decrypt 解密]
* @return {[type]} [description]
*/
function decrypt (content, key, iv) {
  var keyStr = CryptoJS.enc.Utf8.parse(key || keyStrIvStr.keyStr); //密钥，16位
  var ivStr = CryptoJS.enc.Utf8.parse(iv || keyStrIvStr.ivStr); //偏移量，16位
  var bytes = CryptoJS.AES.decrypt(content.toString(), keyStr, {
    iv: ivStr,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  var decryptResult = bytes.toString(CryptoJS.enc.Utf8);
  return decryptResult;
}

export { encrypt, decrypt }

export default {
  install (Vue, options) {
    Vue.prototype.$aesEncrypt = encrypt
    Vue.prototype.$aesDecrypt = decrypt
  }
}